import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import PouchDB from "pouchdb-browser";
import { useDoc } from "use-pouchdb";
import _ from "lodash";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import Cancel from "@mui/icons-material/Cancel";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import Paper from "@mui/material/Paper";
import Camera from "./Camera";
import { styled } from "@mui/material/styles";
import { current, completed } from "./../../utilities/state";

const localDB = new PouchDB('delfornoqsc', { revs_limit: 1 });

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: theme.spacing(3),
    color: theme.palette.text.secondary,
}));

function Question(props) {

    const _current = useRecoilValue(current);
    const _setCompleted = useSetRecoilState(completed);
    const [score, setScore] = useState('');
    const [comment, setComment] = useState('');
    const [images, setImages] = useState([]);
    const [showComment, setShowComment] = useState(false);
    const [showImages, setShowImages] = useState(false);
    const [open, setOpen] = useState(false);
    const [openCamera, setOpenCamera] = useState(false);
    const { doc, loading } = useDoc(_current);
    const imagePath = "https://qsc.delforno.co.za/files/";

    const handleChange = (event) => {
        let _score = event.target.value;
        setScore(_score);

        let answer = _.find(doc.answers, { 'questionId': props.questionId });

        if (answer) {
            answer.score = _score;
        } else {
            let answer = {
                questionId: props.questionId,
                score: _score,
                comment: '',
                images: []
            }
            doc.answers.push(answer);
        }

        localDB.put(doc);
        let completed = _.countBy(doc.answers, o => o.score !== '').true;
        _setCompleted(completed);
    };

    const handleCommentChange = (event) => {
        let _comment = event.target.value;
        setComment(_comment);
    };

    const saveCommentChange = () => {

        let answer = _.find(doc.answers, { 'questionId': props.questionId });

        if (answer) {
            answer.comment = comment;
        } else {
            let answer = {
                questionId: props.questionId,
                comment: comment
            }
            doc.answers.push(answer);
        }

        localDB.put(doc);

        if (comment === '') {
            setShowComment(false);
        }
    };

    const saveQuestionImages = (images) => {
       
        let answer = _.find(doc.answers, { 'questionId': props.questionId });

        if (answer) {
            answer.images = images;
        } else {
            let answer = {
                questionId: props.questionId,
                images: images
            }
            doc.answers.push(answer);
        }

        localDB.put(doc);
        handleCameraClose(true);
    }

    const getMenuItems = () => {


        let content = [];

        if (props.isPassFail) {
            content.push(<MenuItem value={0} key={1}>Fail</MenuItem>);
            content.push(<MenuItem value={1} key={2}>Pass</MenuItem>);
            content.push(<MenuItem value={-1} key={3}>N/A</MenuItem>);
            return content;
        }

        if (props.lowScore === 0) {
            content.push(<MenuItem value={0} key={1}>0</MenuItem>);
            content.push(<MenuItem value={props.maxScore} key={2}>{props.maxScore}</MenuItem>);
            content.push(<MenuItem value={-1} key={3}>N/A</MenuItem>);
            return content;
        }

        if (props.lowScore === -1) {
            for (var i = props.lowScore + 1; i < parseInt(props.maxScore) + 1; i++) {
                content.push(<MenuItem value={i} key={i}>{i}</MenuItem>);
            }
            content.push(<MenuItem value={-1} key={-1}>N/A</MenuItem>);
            return content;
        }

        return content;
    };

    const clearQuestion = () => {

        let answer = _.find(doc.answers, { 'questionId': props.questionId });
        let completed = _.countBy(doc.answers, o => o.score !== '').true - 1;
        _setCompleted(completed);

        answer.score = '';
        answer.comment = '';
        answer.images = [];
        setComment('');
        setShowComment(false);
        setImages([]);
        setShowImages(false);
        localDB.put(doc);
        handleClose();

    }

    const deleteImage = (image) => {

        let _images = _.clone(images);
        var index = _images.indexOf(image);
        if (index > -1) {
            _images.splice(index, 1);
        }

        setImages(_images);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCameraClose = () => {
        setOpenCamera(false);
    };

    useEffect(() => {

        if (doc && !loading) {

            let answer = _.find(doc.answers, { 'questionId': props.questionId });
            if (answer) {
                setScore(answer.score);
                if (answer.comment?.length > 0) {
                    setComment(answer.comment);
                    setShowComment(true);
                }
                if (answer.images?.length > 0) {
                    setImages(answer.images);
                    setShowImages(true);
                }
            }

        }

    }, [_current, doc, loading, props.questionId]);

    return (
        <Item elevation={score !== '' ? 0 : 2} style={{ backgroundColor: score !== '' ? '#f1f1f1' : '#fff', position: 'relative' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                    <Box sx={{ flex: 1, fontWeight: 'bold', color: '#000' }}>
                        {props.question}
                    </Box>
                </Grid>
                <Grid item xs={6} md={2}>
                    <Box sx={{ width: 100, marginRight: 2 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Score</InputLabel>
                            <Select value={score} label="Score" onChange={handleChange} >
                                {getMenuItems()}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xs={6} md={2}>
                    <Box sx={{ width: 100, marginRight: 2, display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ width: 50 }}>
                            <IconButton component="label" onClick={() => setShowComment(!showComment)}>
                                <ChatBubbleOutlineIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ width: 50, marginRight: 2 }}>
                            <IconButton component="span" onClick={() => setOpenCamera(true)}>
                                <PhotoCamera />
                            </IconButton>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Box sx={{ margin: 1, marginTop: 2, display: showComment ? 'visible' : 'none' }}>
                <TextField label="Comment" multiline maxRows={3} value={comment} onChange={handleCommentChange} onBlur={saveCommentChange} style={{ width: '100%' }} />
            </Box>
            <Box sx={{ display: showImages ? 'visible' : 'none' }}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {images.map((image, index) => (
                        <Box key={index} sx={{ width: "120px", paddingRight: "12px", position: 'relative', ml: 1, mt: 1 }}>
                            <img alt="cam" src={imagePath + image} style={{ width: "100%" }} />
                            <Box sx={{ position: 'absolute', right: -12, top: -20 }}>
                                <IconButton component="span" onClick={() => deleteImage(image)}>
                                    <Cancel size="xs" color={'warning'} />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            {
                score !== '' &&
                <Box sx={{ position: 'absolute', right: -14, top: -14 }}>
                    <IconButton component="span" onClick={() => handleClickOpen()} >
                        <Cancel size="xs" color={'warning'} />
                    </IconButton>
                </Box>
            }
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Clear question?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to clear this questions score, comments and images?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>No</Button>
                    <Button onClick={() => clearQuestion()} autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal open={openCamera} onClose={handleCameraClose} >
                <Box sx={{ backgroundColor: '#fff', margin: 4, height: '90vh' }}>
                    <Camera handleCameraClose={handleCameraClose} saveQuestionImages={saveQuestionImages} questionId={props.questionId} storeId={_current} />
                </Box>
            </Modal>
        </Item>
    )
}

export default Question
